import React from 'react';
import { cn } from '@/helpers/classnames';

interface SkeletonProps extends React.HTMLAttributes<HTMLDivElement> {
  /**
   * `text` sits on the line it replaces and inherits the surrounding font size,
   * `circle` is a square-aspect dot, `block` fills the width it is given.
   */
  variant?: 'text' | 'circle' | 'block';
}

const Skeleton: React.FC<SkeletonProps> = ({
  variant = 'text',
  className,
  ...props
}) => (
  <div
    aria-hidden="true"
    className={cn(
      variant === 'text' && 'skeleton-text',
      variant === 'circle' && 'skeleton-circle',
      variant === 'block' && 'skeleton-block',
      className,
    )}
    {...props}
  />
);

export default Skeleton;
